/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck

// TODO: Getting error from at-loader, hence using @ts-nocheck
// Property 'use' does not exist on type 'typeof import("node_modules/i18next/index")'.

import i18n from 'i18next';
import LngDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import defaultLocalePuff from './stringTranslation.puff.json';
import convertPuffToJson from './puff-j-converter';

// This languageMap is defined statically as vite wasn't able to resolve the webpack loader '@amzn/katal-localization/dist/webpack/localization-loader!'
// Currently this MVP product is only intended for internal users in India. Code logic to detect other MP (Market Place) needs to be added if the product is released for other MPs
const languageMap: Record<string, string> = {
  'ar-AE': '/translations/stringTranslation-ar-AE.puff.json',
  'de-DE': '/translations/stringTranslation-de-DE.puff.json',
  'en-AU': '/translations/stringTranslation-en-AU.puff.json',
  'en-CA': '/translations/stringTranslation-en-CA.puff.json',
  'en-GB': '/translations/stringTranslation-en-GB.puff.json',
  'en-IN': '/translations/stringTranslation-en-IN.puff.json',
  'en-SG': '/translations/stringTranslation-en-SG.puff.json',
  'en-US': '/translations/stringTranslation-en-US.puff.json',
  'es-CO': '/translations/stringTranslation-es-CO.puff.json',
  'es-ES': '/translations/stringTranslation-es-ES.puff.json',
  'es-MX': '/translations/stringTranslation-es-MX.puff.json',
  'fr-CA': '/translations/stringTranslation-fr-CA.puff.json',
  'fr-FR': '/translations/stringTranslation-fr-FR.puff.json',
  'hi-IN': '/translations/stringTranslation-hi-IN.puff.json',
  'it-IT': '/translations/stringTranslation-it-IT.puff.json',
  'ja-JP': '/translations/stringTranslation-ja-JP.puff.json',
  'ko-KR': '/translations/stringTranslation-ko-KR.puff.json',
  'nl-NL': '/translations/stringTranslation-nl-NL.puff.json',
  'pl-PL': '/translations/stringTranslation-pl-PL.puff.json',
  'pt-BR': '/translations/stringTranslation-pt-BR.puff.json',
  'sv-SE': '/translations/stringTranslation-sv-SE.puff.json',
  'ta-IN': '/translations/stringTranslation-ta-IN.puff.json',
  'th-TH': '/translations/stringTranslation-th-TH.puff.json',
  'tr-TR': '/translations/stringTranslation-tr-TR.puff.json',
  'vi-VN': '/translations/stringTranslation-vi-VN.puff.json',
  'zh-CN': '/translations/stringTranslation-zh-CN.puff.json',
  'zh-TW': '/translations/stringTranslation-zh-TW.puff.json',
};

/**
 * This is to prevent TS error:
 * Type 'DefaultTFuncReturn' is not assignable to type 'string' in i18next
 * https://www.i18next.com/overview/typescript
 */
declare module 'i18next' {
  interface CustomTypeOptions {
    returnNull: false;
  }
}

const defaultLocale = 'en-US';
const isDevelopment = process.env.NODE_ENV !== 'production';
// Whether initialization is complete or not
let isInitialized = false;
// If initialization is complete, if any the last error
let initializationError: string | undefined;
type I18nCallback = (err?: string) => void;
// Registered callbacks for when i18n initialization completes
const i18nInitializationCallbacks: I18nCallback[] = [];

i18n
  .use(HttpApi)
  .use(LngDetector)
  .use(initReactI18next)
  .init({
    returnNull: false,
    react: {
      useSuspense: true,
    },
    debug: isDevelopment,
    fallbackLng: defaultLocale,
    load: 'currentOnly',
    backend: {
      loadPath: (languages) => languageMap[languages[0]],
    },
    detection: {
      // order and from where user language should be detected
      order: ['htmlTag', 'navigator', 'localStorage'],
    },
    // By default, the values get escaped to mitigate XSS attacks
    // since BHS strings are coming from local puff file, no possibility of XSS
    // Hence setting the escapeValue option to false when requesting a translation.
    interpolation: { escapeValue: false },
  })
  .then((err?: string) => {
    initializationError = err;
    isInitialized = true;
    i18nInitializationCallbacks.forEach((callback) => {
      callback(initializationError);
    });
    i18nInitializationCallbacks.length = 0;
  });

/**
 * Helper function to run the given callback to report the status of translation initialization.
 *
 * If translation is already initialized the callback will run immediately, otherwise it will run
 * when translation initialization is complete.
 *
 * This helper function fills a gap in the i18next library, where it doesn't report the initialization
 * status through any of its own events or status flags.
 */
const i18nWhenReady = (callback: I18nCallback) => {
  if (isInitialized) {
    callback(initializationError);
  } else {
    i18nInitializationCallbacks.push(callback);
  }
};

// Enabling the rollback for production as well
// Reason: https://quip-amazon.com/B8vcAj5rjbdC/Handling-Translations-in-Pi
// if (isDevelopment) {
const defaultDevLanguage = convertPuffToJson(defaultLocalePuff);
i18n.addResourceBundle(defaultLocale, 'translation', defaultDevLanguage);
// }

const translation = i18n.t.bind(i18n);
export { i18nWhenReady, translation as t, defaultLocale };
export default i18n;
